var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-time-container"},[_c('div',{staticClass:"record-icon"}),_c('span',{staticClass:"room-time"},[_vm._v(_vm._s(_vm.convertTime(_vm.totalSeconds)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }